export const POPULATE_CALENDAR = 'POPULATE_CALENDAR';
export const UPDATE_AND_POPULATE_CALENDAR = 'UPDATE_AND_POPULATE_CALENDAR';
export const FILTER_AND_POPULATE_CALENDAR = 'FILTER_AND_POPULATE_CALENDAR';
export const SET_ERROR = 'SET_ERROR';